import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";

import { t } from "../../nonview/base/I18N";

import AppColors from "../../view/_constants/AppColors";
import IconLabel from "../../view/molecules/IconLabel";
import LabelledText from "../../view/molecules/LabelledText";

export default function TrustedIssuerView({ trustedIssuer, short }) {
  if (!trustedIssuer) {
    return (
      <Alert severity="error">
        {t("This token has been generated by an untrusted source party")}
      </Alert>
    );
  }

  if (short) {
    return (
      <IconLabel
        label="Trusted Issuer"
        color={AppColors.ValidText}
        additionalText={trustedIssuer.name}
      />
    );
  } else {
    return (
      <Box>
        <LabelledText
          label="Trusted Issuer"
          text={trustedIssuer.name}
          color={AppColors.ValidText}
        />
        <LabelledText
          label="Public Key"
          text={trustedIssuer.publicKey}
          color={AppColors.ValidText}
        />
      </Box>
    );
  }
}
